import type { ReactNode } from "react";

export interface BadgeProps {
  children: ReactNode;
  tone?: "accent" | "neutral";
}

export function Badge({ children, tone = "neutral" }: BadgeProps) {
  return <span className={`jaiho-badge jaiho-badge--${tone}`}>{children}</span>;
}
